import { selectBuildingInfoByTypeId } from "../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../utils/utilBuildings";
import { IdTutorialStep } from "../IdTutorialStep";
import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialSowClickAcre = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var _a = selectTutorialConfigData(state), tutorialStepConfig = _a.tutorialStepConfig, nextTutorialStepConfig = _a.nextTutorialStepConfig;
    if (tutorialStepConfig.nextStep !== IdTutorialStep.sowWildflowers_clickAcre) {
        return undefined;
    }
    var hasBuildingId = nextTutorialStepConfig.buildingId !== undefined &&
        action.building.balancing.id === tutorialStepConfig.buildingId;
    if (!hasBuildingId) {
        return undefined;
    }
    var focusBuilding = selectBuildingInfoByTypeId(state, nextTutorialStepConfig.buildingId);
    var hasFinishedProduction = utilBuildings.hasFinishedProduction(focusBuilding, state.productionInfo.removedProductions);
    return hasFinishedProduction ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialSowClickAcre.ts
// module id = 2480
// module chunks = 3